var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBriefcaseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bx-layout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.545,
    height: 25.545,
    viewBox: "0 0 25.545 25.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    width: 25.545,
    height: 25.545,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M18.246,6.322H15.379V5.367A2.867,2.867,0,0,0,12.512,2.5H10.6A2.867,2.867,0,0,0,7.734,5.367v.956H4.867A2.867,2.867,0,0,0,2,9.189v8.6a2.867,2.867,0,0,0,2.867,2.867H18.246a2.867,2.867,0,0,0,2.867-2.867v-8.6A2.867,2.867,0,0,0,18.246,6.322Zm-8.6-.956a.956.956,0,0,1,.956-.956h1.911a.956.956,0,0,1,.956.956v.956H9.645ZM19.2,17.79a.956.956,0,0,1-.956.956H4.867a.956.956,0,0,1-.956-.956V12.534A20.746,20.746,0,0,0,11.556,14,20.785,20.785,0,0,0,19.2,12.534Zm0-7.349a19.007,19.007,0,0,1-15.29,0V9.189a.956.956,0,0,1,.956-.956H18.246a.956.956,0,0,1,.956.956Z",
    transform: "translate(1.194 0.288)",
    fill: "#b5b5b5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseIcon);
export default __webpack_public_path__ + "static/media/briefcase-icon.6d55d2fea96aecae7078dcc38086f39b.svg";
export { ForwardRef as ReactComponent };